<template>
        <span class="tag is-pulled-right" v-bind:style="{'background-color' : category.color, 'color' : category.text_color}" >{{category.name}}</span>
</template>
<script>

    import _ from 'lodash'

    export default {
        name: 'CategoryTag',
        components: {},
        props:['category'],
        data() {
            return {
            }
        },
        created(){

        },
        mounted(){

        },
        methods: {
        },
        watch: {}

    }
</script>

<style lang="css" scoped>

        @media screen and (max-width: 768px){
                span.tag{
                        width: 100%;
                }
        }

</style>



// WEBPACK FOOTER //
// src/components/premade-comments/components/CategoryTag.vue